import memeService from "../../../../services/MemeService";
import { useState } from "react";
import Container from "../../../common/Container";
import { useTranslation } from "react-i18next";
import LanguageDisplay from "./languageDisplay";
import BrowserSourceStateDisplayComponent from "./browserSourceStateDisplayComponent/index";
import pollingService from "../../../../services/PollingService";
import Cookies from "universal-cookie";

const AccountSettings = () => {
    const cookies = new Cookies();
    const { t } = useTranslation("settings");

    const [browserSourceIsActive, setBrowserSourceIsActive] = useState(false);
    const isMonetized = cookies.get("isMonetized");

    pollingService.usePollingInterval(async () => {
        let result = await memeService.isBrowserSourceActive();
        setBrowserSourceIsActive(result.isBrowserSourceActive);
    }, 1000 * 30);

    const content1 = <LanguageDisplay />;
    const content2 = (
        <p className="testMemeMessageText">
            {isMonetized === "true"
                ? t("monetizationStatusIsActive")
                : t("monetizationStatusIsInactive")}
        </p>
    );
    const content3 = (
        <BrowserSourceStateDisplayComponent
            browserSourceIsActive={browserSourceIsActive}
        />
    );
    let display = (
        <div className="scrollableContainer">
            <Container
                content={
                    <>
                        <Container content={content1} dynamicContainer={true} />
                        <Container content={content2} dynamicContainer={true} />
                        <Container content={content3} dynamicContainer={true} />
                    </>
                }
                dynamicContainerDiv={true}
            />
        </div>
    );

    return display;
};

export default AccountSettings;
